import './brand.css'
export default function Brand(props){
  const brands = [
    "Visit",
    "Max well",
    "Beme",
    "Wellastrate",
    "Kamand",
    "Mahogany",
    "Limcon",
    "2004",
    "Maya",
    "Salonformula",
    "Welloxon",
    "Kaman",
    "Handsan",
    "Maxdent",
    "Nabat",
    "Ziro",
    "Nano",
    "Max moore",
    "Fighter",
    "Welondo",
    "Magma",
    "Cult",
    "Robinson",
    "Headline",
    "Kamand 2000",
    "Nagma",
  ];
  const randomValue = () => Math.floor(Math.random() * 156) + 100;

const generateRandomColor = () => {
  return `rgb(${randomValue()}, ${randomValue()}, ${randomValue()})`;
};
return (
  <div className="brands-container">
    <div className='brandlist'>
    {brands.map((brand, index) => (
      <div
        key={index}
        className="brand-item"
        style={{ backgroundColor: generateRandomColor() }}
      >
        {brand}
      </div>
    ))}
    </div>
    <div className="standards-section">
  <div className="standards-text">
        {props.language === 'en' ? (
          <div style={{direction: 'ltr'}}>
            <h2>Global Standards</h2>
            <p>
              With over 89 years of experience, Tehran Mo Company is one of the largest manufacturers of beauty and personal care products. To establish a regulated system and a dynamic environment, the following management systems have been implemented in the corporate and production environments:
            </p>
            <ul>
              <li>ISO 14001:2015</li>
              <li>ISO 45001:2018</li>
              <li>ISO 10002:2018</li>
              <li>ISO 10004:2018</li>
              <li>EC Europ</li>
              <li>ISO 19001:2015</li>
              <li>GMP (P&G Approval)</li>
              <li>GMP (Local Regulation)</li>
            </ul>
            <p>
              The company has adopted these standards as its operational model. In this regard, the management is committed to applying these standards' requirements and continuously improving them within the organization.
            </p>
            <p>
              Tehran Mo Company, in pursuit of its goals, introduces the following values as part of its path to excellence:
            </p>
            <ul>
              <li>Customer satisfaction as the top priority.</li>
              <li>Compliance with national and international regulations.</li>
              <li>Commitment to producing high-quality products and offering services worthy of the customers' trust.</li>
              <li>Positive impact on the national economy.</li>
              <li>Utilization of up-to-date knowledge and technology.</li>
              <li>Innovation and creativity to meet customers' needs and improve their quality of life.</li>
              <li>Honesty and transparency in internal and external communications.</li>
              <li>Responsibility toward society and value creation for stakeholders.</li>
              <li>Environmental protection.</li>
              <li>Meritocracy and respect for human dignity.</li>
            </ul>
          </div>
        ) : (
          <div>
            <h2>استانداردهای جهانی</h2>
            <p>
              شرکت تهران مو با سابقه 89 سال، یکی از بزرگترین تولیدکنندگان محصولات آرایشی و بهداشتی است. این شرکت به منظور ایجاد نظامی قانونمند و محیطی پویا، سیستم‌های مدیریتی زیر را در محیط شرکتی و تولیدی ایجاد نموده است:
            </p>
            <ul>
              <li>ISO 14001:2015</li>
              <li>ISO 45001:2018</li>
              <li>ISO 10002:2018</li>
              <li>ISO 10004:2018</li>
              <li>EC Europ</li>
              <li>ISO 19001:2015</li>
              <li>GMP (تأیید P&G)</li>
              <li>GMP (مقررات محلی)</li>
            </ul>
            <p>
              این شرکت این استانداردها را به عنوان الگوی کاری خود قرار داده است. در این راستا، مدیریت شرکت تعهد می‌نماید که الزامات کاربرد این استانداردها را به همراه بهبود مستمر در سازمان اجرایی نماید.
            </p>
            <p>
              شرکت تهران مو در راستای نیل به اهداف خود، ارزش‌های زیر را به عنوان مسیر تعالی سازمان خود معرفی می‌کند:
            </p>
            <ul>
              <li>مشتری‌مداری و رضایت مشتری به عنوان اولویت نخست.</li>
              <li>پایبندی به قوانین و مقررات ملی و بین‌المللی.</li>
              <li>تعهد کارکنان به تولید محصولاتی با کیفیت و ارائه خدماتی در خور شأن مشتریان.</li>
              <li>اثرگذاری مثبت بر اقتصاد کشور.</li>
              <li>بهره‌گیری از دانش و فن‌آوری روزآمد.</li>
              <li>نوآوری و خلاقیت برای پاسخگویی به نیاز مشتری و ارتقای کیفیت زندگی آنان.</li>
              <li>صداقت و صراحت در ارتباطات درون‌سازمانی و برون‌سازمانی.</li>
              <li>مسئولیت‌پذیری در قبال جامعه و ارزش‌آفرینی برای ذی‌نفعان.</li>
              <li>حفظ محیط‌زیست.</li>
              <li>شایسته‌سالاری و توجه به کرامت انسانی.</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  </div>
);
}